const htmlData = {
    privacyPolicy: `<div className="content">
    <h4>GENERAL</h4>
    <br />
    <br />
    <p>
        The website <a href="https://www.elitepartyz.com">www.elitepartyz.com</a> and the Elite Partyz App and the services provided by these are owned and operated by Elite Partyz
    </p>
    <br />
    <br />
    <p>
        This Privacy Policy outlines the collection and use of your personal information. We may collect your personal information anytime you interact with Elite Partyz, such as when you visit our website, use our App, subscribe to our services or when you are in contact with one of our representatives by way of phone or email. Please read this policy carefully to understand more about our information practices, including:
    </p>
    <ul>
        <li>The type of information we may collect</li>
        <li>How the information may be used and for what purpose</li>
        <li>To whom we disclose the information</li>
    </ul>
    <br />
    <h4>PRIVACY POLICY</h4>
    <br />
    <br />
    <p>Elite Partyz is committed to providing quality services to you and the policy outlines our ongoing obligations to you in respect of how we manage your personal information. We have adopted the Australian Privacy Principles (AAPs) contained in the Privacy Act 1988 (cth) (The Privacy Act). He NPPS governs the way in which we collect, use, disclose, store, secure and dispose of your personal information.</p>
    <br />
    <br />
    <p>
        A copy of the Australian Privacy Principles may be obtained from the website of The Office of the Australian Information Commissioner at <a href="https://www.aoic.gov.au">www.aoic.gov.au</a> 
    </p>
    <br />
    <br />
    <h4>WHAT IS PERSONAL INFORMATION AND WHY DO WE COLLECT IT?</h4>
    <br />
    <br />
    <p>Personal Information is information or an opinion that identifies an individual. Examples of personal information we collect include; names, addresses, email addresses, phone, facsimile numbers and ABN.</p>
    <br />
    <br />
    <p>This personal information is obtained in many ways including the inputs provided by you at the time of your subscription, correspondence between Elite Partyz and you, by telephone and facsimile, by email, via our website <a href="https://www.elitepartyz.com">www.elitepartyz.com</a>, from your website, from media and publications, from other publicly available sources, from cookies and from third parties. We don’t guarantee website links or policy of authorised third parties.</p>
    <br />
    <br />
    <p>We collect your personal information for the primary purpose of providing our services to you, providing information to our clients, suppliers and marketing. We may also use your personal information for secondary purposes closely related to the primary purpose, in circumstances where you would reasonably expect such use or disclosure. You may unsubscribe from our mailing/marketing lists at any time by contacting us in writing.
    </p>
    <br />
    <br />
    <p>When we collect Personal Information we will, where appropriate and where possible, explain to you why we are collecting the information and we plan to use it.
    </p>
    <br />
    <br />
    <h4>SENSITIVE INFORMATION</h4>
    <br />
    <br />
    <p>Sensitive Information is defined in the Privacy Act to include information or opinion about such things about such things as an individual’s racial or ethnic origin, political opinions, membership of a political association, religious or philosophical beliefs, membership of a trade union or other professional body, criminal record or health information.
    </p>
    <br />
    <br />
    <p>Sensitive information will be used by us only;</p>
    <br />
    <br />
    <ul>
        <li>For the primary purpose for which it was obtained</li>
        <li>For a secondary purpose that is directly related to the primary purpose</li>
        <li>With your consent; or where required or authorised by law.</li>
    </ul>
    <br />
    <br />
    <h4>THIRD PARTIES</h4>
    <br />
    <br />
    <p>Where reasonable and practicable to do so, we will collect your personal information only from you. However, in some circumstances we may be provided with information by third parties. In such a case we will take reasonable steps to ensure that you are made aware of the information provided to us by the third party.</p>
    <br />
    <br />
    <p>In the event that you are an End-User, we cannot guarantee the privacy of personal information you transmit to a Supplier.</p>
    <br />
    <br />
    <p>Where another website is linked on our website or found on our App (such as the websites of Suppliers), Elite Partyz does not warrant that the third-party site complies with its legal obligations regarding privacy and accessing the third-party site is at the user’s risk in respect of such matters as bugs, inaccuracies, viruses, and the content on the site.</p>
    <br />
    <br />
    <p>End-users are encouraged to consult the privacy notices of Suppliers as we have no control over information that is submitted to, or collected by, these third parties.</p>
    <br />
    <br />
    <h4>DISCLOSURE OF PERSONAL INFORMATION</h4>
    <br />
    <br />
    <p>Your Personal Information may be disclosed in a number of circumstances including the following;</p>
    <br />
    <br />
    <ul>
        <li>Third parties where you consent to the use or disclosure; and</li>
        <li>Where required or authorised by law.</li>
    </ul>
    <br />
    <br />
    <h4>SECURITY OF PERSONAL INFORMATION</h4>
    <br />
    <br />
    <p>Your Personal Information is stored in a manner that reasonably protects it from misuse and loss and from unauthorised access, modification or disclosure.</p>
    <br />
    <br />
    <p>When your Personal Information is no longer needed for the purpose for which it was obtained, we will take reasonable steps to destroy or permanently de-identify your Personal Information. However, most of the Personal Information is or will be stored in client files which will be kept by us for a minimum of 7 years.</p>
    <br />
    <br />
    <h4>ACCESS TO YOUR PERSONAL INFORMTION</h4>
    <br />
    <br />
    <p>You may access the Personal Information we hold about you and to update and/or correct it, subject to certain exceptions. If you wish to access your personal information, please contact us in writing.</p>
    <br />
    <br />
    <p>Elite Partyz will not charge any fee for you access request, but may charge an administrative fee for providing a copy of your Personal Information.</p>
    <br />
    <br />
    <p>In order to protect your Personal Information we may require identification from you before releasing the requested information.</p>
    <br />
    <br />
    <p>In some limited cases, we may need to refuse access to your information. We will advise you as soon as possible after your request if this is the case and the reasons for our refusal.</p>
    <br />
    <br />
    <h4>MAINTAINING THE QUALITY OF YOUR PERSONAL INFORMATION</h4>
    <br />
    <br />
    <p>It is important to us that your Personal Information is up to date. We will take reasonable steps to make sure that your Personal Information is accurate, complete and up-to-date. If you find that the information we have is not up to date or is inaccurate, please advise us as soon as practicable so we can update our records and ensure we can continue to provide quality service to you.</p>
    <br />
    <br />
    <p>In some limited cases, we may need to refuse a request for correction of your information. We will advise you as soon as possible after your request if this is the case and the reasons for our refusal.</p>
    <br />
    <br />
    <h4>POLICY UPDATES</h4>
    <br />
    <br />
    <p>This Policy may change from time to time and is available on our website. The policy may be updated without any notice being provided to you, so we recommend that you regularly visit this Privacy Policy.</p>
    <br />
    <br />
    <h4>PRIVACY POLICY COMPLAINTS AND ENQUIRIES</h4>
    <br />
    <br />
    <p>If you have any queries or complaints about our Privacy Policy please contact us at:</p>
    <br />
    <br />
    <p>Elite Partyz</p>
    <a href="mailto:contact@elitepartysz.com">contact@elitepartysz.com</a>
    <br />
    <br />
    <p>We will use our best endeavours to have a representative of Elite Partyz to respond to your inquiry within 10 business days.</p>
    <br />
    <br />
</div>`,
tramsAndCondition: `<div className="content">
<h4>Terms and Conditions of Use (End-Users)</h4>
<h5>General</h5>
<p>
    Thank you for registering with Elite Partyz (“Elite Partyz”, “we”, “our”, “us”). Elite Partyz operates as a lead generating platform for Suppliers (“Suppliers”, ”Supplier”) whilst simultaneously providing end-users (“end-user”, “user” “customer”, “client” “You”) with a supplier database as a solution for all Your party planning needs, together in one place. 
</p>
<br />
<p>Services (“Service”, “Services”) include the use of the Elite Partyz website: www.elitepartyz.com (“Website”) and Elite Partyz App (“App”). Use of our Services constitutes acceptance of the Terms and Conditions (“Terms of Use”, “Terms”, “Terms of Service”).</p>
<br />
<p>By using the Elite Partyz Service you are indicating that you have read these Terms of Use and our Privacy Policy. These Terms of Service govern your use and access to the Elite Partyz Website and App. Please read these Terms carefully, and contact us if you have any questions.  By accessing or using our Services you agree to be bound by these Terms and by our Privacy Policy. </p>
<br />
<h5>Your Subscription</h5>
<br />
<p>Users must be 18 years or older to subscribe to this Service.</p>
<br />
<p>Although there are no subscription fees for End-users to access the Services of Elite Partyz, You agree to pay Supplier invoices (for the services rendered by the Supplier to You) on time and agree to comply with the Supplier’s terms of engagement (including any Terms and Conditions and Privacy Policy). </p>
<br />
<h5>Data Protection </h5>
<br />
<p>Certain registration information and other information about you may be collected by Elite Partyz and through the service.  Elite Partyz’ use of this information is governed by the Elite Partyz Privacy Policy.</p>
<br />
<p>Elite Partyz shall use reasonable efforts to protect personal information submitted by you in connection with the Elite Partyz Service and shall use such information in accordance with the privacy policy.</p>
<br />
<p>Elite Partyz shall implement and maintain reasonable procedures for protecting personal information in compliance with applicable law and the Elite Partyz Privacy Policy.</p>
<br />
<h5>Liability</h5>
<p>You expressly acknowledge and agree that neither Elite Partyz, any content owner or third party licensor, nor their respective directors, officers, employees, agents, contractors, subcontractors or affiliated companies will be liable for any direct, indirect, incidental, punitive, special, consequential or exemplary damages (even if Elite Partyz or the content owner have been advised of the possibility of such damages) or loss of any kind, arising from your use of the Elite Partyz Service including but not limited to the engagement of a Supplier,  or from any content, information, materials or products included on the App. or otherwise made available to you through the Elite Partyz Service..</p>
<br />
<p>For the avoidance of doubt, You acknowledge that Elite Partyz, the content owner or any third party licensor to Elite Partyz has no responsibility for any actions or omissions by Suppliers, including circumstances where Suppliers have failed to render appropriate services to you as per their terms of engagement in exchange for proper payment made by you.  </p>
<br />
<p>
   You acknowledge and agree that you submission of any information by you to the Supplier by use of the Elite Partyz App. is at your sole risk, and to the maximum extent permitted by law, Elite Partyz hereby disclaims any and all liability to you for any loss or liability relation  to such information in any way.
</p>
<br />
<h5>Intellectual Property Rights</h5>
<br />
<p>The Website and App and all of their contents, features and functionality (including but not limited to all information, software, text, displays, images, video and audio, and the design, selection and arrangement thereof), are owned by Elite Partyz, its licensors, or other providers of such material and are protected by Australian and International copyright, trademark, patent, trade secret, and other intellectual property or proprietary rights laws.</p>
<br />
<p>These Terms of Use grant you a personal, non-exclusive, non-transferable, revocable licence to access and use the Website and App. You must not reproduce, distribute, modify, create derivative works of, publicly display, publicly perform, republish, download, store or transmit any of the material on our Website and App, except as incidental to normal web browser, and for features of the site that enable sharing via email, social media linking, and other platforms expressly enabled by the Website and App. </p>
<br />
<p>You must not:</p>
<ul>
   <li>Modify copies of any material from the Website and App</li>
   <li>Use any illustrations, photographs, video or audio sequences or any graphics separately from the accompanying text.</li>
   <li>Delete or alter any copyright, trademark, or other proprietary right from copies of materials from the Website and App. </li>
   <li>Reserve-engineer or otherwise attempt to steal the software code of the Website and App</li>
</ul>
<br />
<p>Any use of the Website and App not expressly permitted by these Terms of Use is a breach of these Terms of Use and may violate copyright, trademark and other laws and may result in Elite Partyz terminating your access to the Website and the App.</p>
<br />
<h5>Termination:</h5>
<p>You are free to stop using our Services at any time, however we reserve the right to suspend or terminate your access to the Services if;</p>
<br />
<ul>
   <li>You are in breach of these Terms of Use</li>
   <li>You are using the Services in a manner that would cause us legal liability and bring us, a Supplier, the App or other customers into disrepute, disrupt the Service or disrupt others’ use of the Service</li>
   <li>Your behaviour is, in our reasonable opinion, anything less than polite, respectful and patient towards Elite Partyz or Suppliers.</li>
</ul>
<br />
<p>We will use our best endeavours to provide you with reasonable notice via the email address associated with your account, that your conduct breaches these Terms of Use and we will invite you to remedy the conduct that promoted us to contact you.  If after such notice you fail to take the steps reasonably requested to ensure your compliance with these Terms of Use, we reserve the right to immediately terminate or suspend your access to the Service without further notice. </p>
<br />
<h5>Revisions:</h5>
<br />
<p>We may revise these Terms from time to time to better reflect:</p>
<ul>
   <li>Changes to the law</li>
   <li>New regulatory requirements</li>
   <li>Improvements or enhancements made to our Service.</li>
</ul>
<br />
<p> The changes will not be retroactive, and the most current version of the Terms (which will always be on the Elite Partyz Website) will govern our relationship with you. </p>
<br />
<p>We will give you reasonable notice of any change to the Terms. By continuing to access our Services after those revisions become effective, you agree to be bound by the revised Terms.</p>
<br />
<h5>Contact information</h5>
<p>If you have any questions regarding the Agreement you may contact Elite Partyz on:</p>
<a href="mailto:contact@elitepartyz.com">contact@elitepartyz.com</a>
</div>`
}

export default htmlData